import { reactive, readonly } from "vue";

const state = reactive({
  progress: 0,
  assetsLoaded: false,
  lensComplete: false,
});

function setProgress(value) {
  state.progress = Math.min(100, Math.max(0, value));
}

function markAssetsLoaded() {
  state.assetsLoaded = true;
}

function markLensComplete() {
  state.lensComplete = true;
}

export function usePreloader() {
  return {
    state: readonly(state),
    setProgress,
    markAssetsLoaded,
    markLensComplete,
  };
}
